import { FormRs009 } from './../../entity/forms/form-rs009';
import { Rs009CardIComponent } from './partialViews/rs009-card-I.component';
import { FormularioService } from './../../services/formulario.service';
import { NotificationService } from './../../services/notification.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { Rs009CardIIComponent } from './partialViews/rs009-card-II.component';
import { Rs009CardIIIComponent } from './partialViews/rs009-card-III.component';
import { Rs009CardVIComponent } from './partialViews/rs009-card-VI.component';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { Rs009CardVComponent } from './partialViews/rs009-card-V.component';
@Component({
  selector: 'app-form-rs009',
  templateUrl: './form-rs009.component.html',
})
export class FormRs009Component implements OnInit, AfterViewInit {
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formRs009: FormRs009 = new FormRs009();
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  @ViewChild(Rs009CardIComponent, { static: false })
  rs009CardIComponent: Rs009CardIComponent;
  @ViewChild(Rs009CardIIComponent, { static: false })
  rs009CardIIComponent: Rs009CardIIComponent;
  @ViewChild(Rs009CardIIIComponent, { static: false })
  rs009CardIIIComponent: Rs009CardIIIComponent;
  @ViewChild(Rs009CardVIComponent, { static: false })
  rs009CardVIComponent: Rs009CardVIComponent;
  @ViewChild(Rs009CardVComponent, { static: false })
  rs009CardVComponent: Rs009CardVComponent;

  editId: number = 0;

  public areaSelect: string = localStorage.getItem('area-select') || null;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected resumeAllFormsService: ResumeAllFormsService,
    public dialog: MatDialog
  ) {
    this.header = new CabecalhoDTO();
    this.formulario = this.formRs009.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = this.route?.snapshot?.params?.type;
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(
              EnumForm.FormRs009,
              EnumFormType.Edit
            );
          } else {
            this.header = this.generalService.createHeader(
              EnumForm.FormRs009,
              EnumFormType.Details
            );
          }
          if (data.formulario.offline) {
            this.showButtonSync = true;
          }
          await this.updateForm(data);
        } else {

          this.header = this.generalService.createHeader(
            EnumForm.FormRs009,
            EnumFormType.New
          );
          await this.getUser();

        }
      }
      this.editId = this.formulario.get('id').value as number;
    });
  }

  ngOnInit(): void {
    this.header = this.generalService.createHeader(
      EnumForm.FormRs009,
      EnumFormType.New
    );
    this.btnCollapse = true;
    this.loadingSubject.next(false);
  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;

    if (id === 0) {
      const existCerar = await this.checkCerarExist();
      if (existCerar === false && await this.validFormsToSave() === '') {

        await this.buildFormulario();
        this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));

        await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'rs009');

        // CHAMAR MODAL DE CONFIRMACAO
        this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
      }
    } else if (id > 0 && await this.validFormsToSave() === '') {

      await this.buildFormulario();
      this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'rs009');

      // CHAMAR MODAL DE CONFIRMACAO
      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
      // await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'rs009', 'formrs009');
    }

  }

  public async validCalcImpurezas() {
    const cardI = this.rs009CardIComponent.formulario.value;
    const cardII = this.rs009CardIIComponent.formulario.value;

    const amostra = cardI.Peso_Amostra;
    const impurezas = {
      rs009CardIComponent: {
        'Palha': cardI.Palha,
        'Impurezas': cardI.Impurezas,
        'Outras_Sementes': cardI.Outras_Sementes,
      },
      rs009CardIIComponent: {
        'Graos_Ardidos': cardII.Graos_Ardidos,
        'Sabugo': cardII.Sabugo,
        'Graos_Carunchados': cardII.Graos_Carunchados,
        'Sementes_Quebradas': cardII.Sementes_Quebradas,
        'Out_Cultivares': cardII.Out_Cultivares,
      }
    };

    const somaTotal = Object.values(impurezas)
      .reduce((acc, card) => acc.concat(Object.values(card)), [])
      .reduce((total, valor) => total + valor, 0);

    for (const [cardKey, card] of Object.entries(impurezas)) {
      for (const [fieldKey, valor] of Object.entries(card)) {

        if (valor >= amostra) {
          this[cardKey].formulario.get(fieldKey)?.setErrors({ invalidCalc: true });
          continue
        }
        if (somaTotal > amostra) {
          this[cardKey].formulario.get(fieldKey)?.setErrors({ invalidSomaAmostra: true });
        }
        else {
          this[cardKey].formulario.get(fieldKey)?.setErrors({ invalidSomaAmostra: false });
          this[cardKey].formulario.get(fieldKey)?.updateValueAndValidity();
        }

      }
    }


  }

  public async validSabugo() {
    const sabugo = this.rs009CardIIComponent.formulario.get('Sabugo')?.value;
    const palha = this.rs009CardIComponent.formulario.get('Palha')?.value;
    const isComercial = this.generalService.isComercial;

    const sabugoControl = this.rs009CardIIComponent.formulario.get('Sabugo');
    if (sabugoControl) {
        sabugoControl['warning'] = isComercial && sabugo < palha;
    }
  }


  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {

    const values: any[] = valoresAlterados;

    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow

      }

    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'rs009', 'formrs009');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }

    });
  }

  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.rs009CardIComponent.formulario);
    arrForms.push(this.rs009CardIIComponent.formulario);
    arrForms.push(this.rs009CardIIIComponent.formulario);
    arrForms.push(this.rs009CardVIComponent.formulario);
    arrForms.push(this.rs009CardVComponent.formulario);
    return await arrForms;
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {
    if (
      this.header.ScreenType ===
      this.generalService.getEnumFormType(EnumFormType.New)
    ) {
      const usuario: string =
        this.rs009CardIIIComponent.formulario.get('resp_validacao')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.rs009CardIIIComponent.userLogged = usuario;
    } else {
      const validacao: boolean =
        this.rs009CardIIIComponent.formulario.get('validacao')?.value;
      const usuario: string =
        this.rs009CardIIIComponent.formulario.get('resp_validacao')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.rs009CardIIIComponent.formulario
        .get('validacao')
        .setValue(validacao);
      this.rs009CardIIIComponent.formulario
        .get('resp_validacao')
        .setValue(usuario);
      await this.blockFieldValidacao();
    }
  }

  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.rs009CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs009CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs009CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs009CardVIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formRs009.buildForm(
      this.formulario,
      await this.getForms()
    );
  }

  public async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }
    await this.formRs009.updateForm(
      data,
      await this.getForms(),
      this.generalService
    );
    this.rs009CardIComponent.disableNumeroCampo = true;
    this.rs009CardIComponent.safraBasicaOld = data.formulario.safra_basica;
    await this.blockFieldValidacao();
  }

  // INICIO DO CODIGO DE CALCULO

  public async makeCalculations(event?: any): Promise<void> {
    await Promise.all([
      this.getPalha_Impurezas_Outras(),
      this.getDescPalhImpArdiEscler(),
      this.getQtdePalhaImpArdiEsclMi(),
      this.getQtdePalhaMi(),
      this.getQtdeSabugoMi(),
      this.getQtdeImpurezas(),
      this.getPesoGraosAmostra(),
      this.getSementes(),
      this.getSubTotalDescGraoMi(),
      this.getSubTotalDescGraoPorcMi(),
      // await this.getSemRedonda();
      // await this.getSemIntermediaria();
      // await this.getSemPeneira();
      // await this.getSubTotalDescAmostra();
      this.getUmidDed(),
      this.getDesc_Impu_Palh(),
      this.getDescSabugo(),
      this.getTotalDescPalImpSabugo(),
      this.getPesoLiquidoUmido(),
      this.getDescUmid(),
      this.getPesoLiquidoSeco(),
      this.getDescPalhaImpMilho(),
      this.getRendimentoRw(),
      this.validCalcImpurezas(),
      this.validSabugo(),
    ]);
  }

  public async getPalha_Impurezas_Outras(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const palha: number = !!this.rs009CardIComponent.formulario.get('Palha')
        ?.value
        ? (this.rs009CardIComponent.formulario.get('Palha')?.value as number)
        : 0;
      // tslint:disable-next-line: max-line-length
      const outrasSementes: number = !!this.rs009CardIComponent.formulario.get(
        'Outras_Sementes'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Outras_Sementes')
          ?.value as number)
        : 0;
      const impurezas: number = !!this.rs009CardIComponent.formulario.get(
        'Impurezas'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Impurezas')?.value as number)
        : 0;
      const resultado: number = palha + outrasSementes + impurezas;
      this.rs009CardIIIComponent.formulario
        .get('Palha_Impurezas_Outras')
        .setValue(resultado);
    }
  }

  public async getDescPalhImpArdiEscler(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      const palhaImpOutras: number = !!this.rs009CardIIIComponent.formulario.get(
        'Palha_Impurezas_Outras'
      )?.value
        ? (this.rs009CardIIIComponent.formulario.get('Palha_Impurezas_Outras')
          ?.value as number)
        : 0;
      const graosArd: number = !!this.rs009CardIIComponent.formulario.get(
        'Graos_Ardidos'
      )?.value
        ? (this.rs009CardIIComponent.formulario.get('Graos_Ardidos')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: max-line-length
      const esclerocitos: number = !!this.rs009CardIIComponent.formulario.get(
        'Esclerocitos'
      )?.value
        ? (this.rs009CardIIComponent.formulario.get('Esclerocitos')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: max-line-length
      const graosCaru: number = !!this.rs009CardIIComponent.formulario.get(
        'Graos_Carunchados'
      )?.value
        ? (this.rs009CardIIComponent.formulario.get('Graos_Carunchados')
          ?.value as number)
        : 0;

      const sementesQuebradas: number =
        !!this.rs009CardIIComponent.formulario.get('Sementes_Quebradas')?.value
          ? (this.rs009CardIIComponent.formulario.get('Sementes_Quebradas')
            ?.value as number)
          : 0;

      const resultado: number =
        palhaImpOutras + graosArd + esclerocitos + graosCaru + sementesQuebradas;

      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Desc_Palh_Imp_Ardi_Escler')
        .setValue(resultado);
    }

  }

  public async getQtdePalhaImpArdiEsclMi(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const descPalhImpArdiEscler: number =
        !!this.rs009CardIIIComponent.formulario.get('Desc_Palh_Imp_Ardi_Escler')
          ?.value
          ? (this.rs009CardIIIComponent.formulario.get(
            'Desc_Palh_Imp_Ardi_Escler'
          )?.value as number)
          : 0;
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get(
        'Peso_Amostra'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoAmostra > 0 && descPalhImpArdiEscler > 0) {
      resultado = this.generalService.CalcPorc(
        descPalhImpArdiEscler,
        pesoAmostra
      );
      // } else {
      //     resultado = 0;
      // }
      this.rs009CardIIIComponent.formulario
        .get('Qtde_Palh_Imp_Ardi_Escl')
        .setValue(resultado);
    }

  }

  public async getQtdePalhaMi(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const palha: number = !!this.rs009CardIComponent.formulario.get('Palha')?.value
        ? (this.rs009CardIComponent.formulario.get('Palha')?.value as number)
        : 0;
  
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get('Peso_Amostra')?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')?.value as number)
        : 0;
  
      let resultado: number = 0;
  
      if (pesoAmostra > 0 && palha > 0) {
        resultado = this.generalService.CalcPorc(palha, pesoAmostra);
      }
  
      const qtdePalhaControl = this.rs009CardIIIComponent.formulario.get('Qtde_Palha');
      qtdePalhaControl.setValue(resultado);
  
      qtdePalhaControl['warning'] = resultado > 5 ? true : false;
    }
  }

  public async getQtdeSabugoMi(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      const palha: number = !!this.rs009CardIIComponent.formulario.get('Sabugo')
        ?.value
        ? (this.rs009CardIIComponent.formulario.get('Sabugo')?.value as number)
        : 0;
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get(
        'Peso_Amostra'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoAmostra > 0 && palha > 0) {
      resultado = this.generalService.CalcPorc(palha, pesoAmostra);
      // } else {
      //     resultado = 0;
      // }
     
      const qtdeSabugoControl = this.rs009CardIIIComponent.formulario.get('Qtde_Sabugo');
      qtdeSabugoControl.setValue(resultado);

      qtdeSabugoControl['warning'] = resultado > 5 ? true : false;

    }

  }

  public async getQtdeImpurezas(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const impurezas: number = !!this.rs009CardIComponent.formulario.get(
        'Impurezas'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Impurezas')?.value as number)
        : 0;
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get(
        'Peso_Amostra'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoAmostra > 0 && impurezas > 0) {
      resultado = this.generalService.CalcPorc(impurezas, pesoAmostra);
      // } else {
      //     resultado = 0;
      // }

      const qtdeImpurezasControl = this.rs009CardIIIComponent.formulario.get('Qtde_Impurezas');
      qtdeImpurezasControl.setValue(resultado);
  
      qtdeImpurezasControl['warning'] = resultado > 3 ? true : false;
    }
  }

  public async getPesoGraosAmostra(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get(
        'Peso_Amostra'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')
          ?.value as number)
        : 0;
      const desconto: number = !!this.rs009CardIIIComponent.formulario.get(
        'Desc_Palh_Imp'
      )?.value
        ? (this.rs009CardIIIComponent.formulario.get('Desc_Palh_Imp')
          ?.value as number)
        : 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoAmostra > 0 && desconto > 0) {
      resultado = pesoAmostra - desconto;
      // } else {
      //     resultado = 0;
      // }
      this.rs009CardIIIComponent.formulario
        .get('Peso_Graos_Amostra')
        .setValue(resultado);
    }

  }

  public async getSementes(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number = !!this.rs009CardIComponent.formulario.get(
        'Peso_Amostra'
      )?.value
        ? (this.rs009CardIComponent.formulario.get('Peso_Amostra')
          ?.value as number)
        : 0;
      const palhaImpOutras: number = this.rs009CardIIIComponent.formulario.get(
        'Palha_Impurezas_Outras'
      ).value;
      // tslint:disable-next-line: max-line-length
      const graosArdidos: number =
        this.rs009CardIIComponent.formulario.get('Graos_Ardidos').value;
      const sabugo: number =
        this.rs009CardIIComponent.formulario.get('Sabugo').value;
      const graosCarunchados: number =
        this.rs009CardIIComponent.formulario.get('Graos_Carunchados').value;
      // tslint:disable-next-line: max-line-length
      const semQuebradas: number =
        this.rs009CardIIComponent.formulario.get('Sementes_Quebradas').value;
      // tslint:disable-next-line: max-line-length
      const outCultivares: number =
        this.rs009CardIIComponent.formulario.get('Out_Cultivares').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // tslint:disable-next-line: max-line-length
      // if (pesoAmostra > 0 && palhaImpOutras > 0 && graosArdidos > 0 && sabugo > 0 && graosCarunchados > 0 && semQuebradas > 0 && outCultivares > 0) {
      resultado =
        pesoAmostra -
        palhaImpOutras -
        graosArdidos -
        sabugo -
        graosCarunchados -
        semQuebradas -
        outCultivares;
      // } else {
      //     resultado = 0;
      // }
      this.rs009CardIIIComponent.formulario.get('Sementes').setValue(resultado);
    }
  }

  public async getSubTotalDescGraoMi(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const graosCarunchados: number =
        this.rs009CardIIComponent.formulario.get('Graos_Carunchados').value;
      // tslint:disable-next-line: max-line-length
      // const descGraos: number = this.rs009CardIIIComponent.formulario.get('Descarte_Graos').value;
      // tslint:disable-next-line: max-line-length
      const semQuebradas: number =
        this.rs009CardIIComponent.formulario.get('Sementes_Quebradas').value;
      // tslint:disable-next-line: max-line-length
      const outCultivares: number =
        this.rs009CardIIComponent.formulario.get('Out_Cultivares').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (graosCarunchados > 0 && descGraos > 0 && semQuebradas > 0 && outCultivares > 0) {
      //     resultado = graosCarunchados - descGraos - semQuebradas - outCultivares;
      // if (graosCarunchados > 0 && semQuebradas > 0 && outCultivares > 0) {
      resultado = graosCarunchados - semQuebradas - outCultivares;
      // } else {
      //     resultado = 0;
      // }
      this.rs009CardIIIComponent.formulario
        .get('Sub_Total_Desc_Grao_g')
        .setValue(resultado);
    }

  }

  public async getSubTotalDescGraoPorcMi(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const subTotalDescGrao: number = this.rs009CardIIIComponent.formulario.get(
        'Sub_Total_Desc_Grao_g'
      ).value;
      // tslint:disable-next-line: max-line-length
      const pesoAmostra: number =
        this.rs009CardIIIComponent.formulario.get('Peso_Graos_Amostra').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoAmostra > 0 && subTotalDescGrao > 0) {
      resultado = this.generalService.CalcPorc(subTotalDescGrao, pesoAmostra);
      // } else {
      //     resultado = 0;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Sub_Total_Desc_Grao_porc')
        .setValue(resultado);
    }

  }

  // public async getSemRedonda(): Promise<void> {
  //     // tslint:disable-next-line: max-line-length
  //     const semRedond: number = this.rs009CardIIIComponent.formulario.get('Sem_Redond').value;
  //     // tslint:disable-next-line: no-inferrable-types
  //     let resultado: number = 0;
  //     if (semRedond > 0) {
  //         resultado = this.generalService.CalcPorc(semRedond, 500);
  //     } else {
  //         resultado = 0;
  //     }
  //     this.rs009CardIIIComponent.formulario.get('Semente_Redonda').setValue(resultado);
  // }

  // public async getSemIntermediaria(): Promise<void> {
  //     // tslint:disable-next-line: max-line-length
  //     const fracaoSem: number = this.rs009CardIIIComponent.formulario.get('Fracao_Sem').value;
  //     // tslint:disable-next-line: no-inferrable-types
  //     let resultado: number = 0;
  //     if (fracaoSem > 0) {
  //         resultado = this.generalService.CalcPorc(fracaoSem, 500);
  //     } else {
  //         resultado = 0;
  //     }
  //     this.rs009CardIIIComponent.formulario.get('Sem_Pen_Intermediaria').setValue(resultado);
  // }

  // public async getSemPeneira(): Promise<void> {
  //     // tslint:disable-next-line: max-line-length
  //     const semPeneira: number = this.rs009CardIIIComponent.formulario.get('Semente_Peneira').value;
  //     // tslint:disable-next-line: no-inferrable-types
  //     let resultado: number = 0;
  //     if (semPeneira > 0) {
  //         resultado = this.generalService.CalcPorc(semPeneira, 500);
  //     } else {
  //         resultado = 0;
  //     }
  //     this.rs009CardIIIComponent.formulario.get('Sem_Pen_Fundo').setValue(resultado);
  // }

  // private async getSubTotalDescAmostra(): Promise<void> {
  //     // tslint:disable-next-line: max-line-length
  //     const semRedonda: number = this.rs009CardIIIComponent.formulario.get('Semente_Redonda').value;
  //     // tslint:disable-next-line: max-line-length
  //     const semPenFundo: number = this.rs009CardIIIComponent.formulario.get('Sem_Pen_Fundo').value;
  //     // tslint:disable-next-line: no-inferrable-types
  //     let resultado: number = 0;
  //     if (semRedonda > 0 && semPenFundo > 0) {
  //         resultado = semRedonda + semPenFundo;
  //     } else {
  //         resultado = 0;
  //     }
  //     // tslint:disable-next-line: max-line-length
  //     this.rs009CardIVComponent.formulario.get('Sub_Total_Descarte_Amostra').setValue(resultado);
  // }

  public async getUmidDed(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const umidade: number =
        Number(this.rs009CardIComponent.formulario.get('Umidade').value)
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (umidade > 0) {
      if (umidade > 13) {
        resultado = ((umidade - 13) * 100) / 87;
      }
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Umidade_Deduzir')
        .setValue(resultado);
    }

  }

  public async getDesc_Impu_Palh(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const qtdePalhImpArdiEscl: number = this.rs009CardIIIComponent.formulario.get('Qtde_Palh_Imp_Ardi_Escl').value;
      // tslint:disable-next-line: max-line-length
      const pesoLiquido: number =
        this.rs009CardIComponent.formulario.get('Peso_Liquido').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (qtdePalhImpArdiEscl > 0 && pesoLiquido > 0) {
      resultado = (qtdePalhImpArdiEscl * pesoLiquido) / 100;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Desc_Impu_Palh')
        .setValue(resultado);
    }

  }

  public async getDescSabugo(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const qtdeSabugo: number =
        this.rs009CardIIIComponent.formulario.get('Qtde_Sabugo').value;
      // tslint:disable-next-line: max-line-length
      const pesoLiquido: number =
        this.rs009CardIComponent.formulario.get('Peso_Liquido').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (qtdeSabugo > 0 && pesoLiquido > 0) {
      resultado = (qtdeSabugo * pesoLiquido) / 100;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Desc_Sabugo')
        .setValue(resultado);
    }
  }

  public async getTotalDescPalImpSabugo(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const descImpuPalh: number =
        this.rs009CardIIIComponent.formulario.get('Desc_Impu_Palh').value;
      // tslint:disable-next-line: max-line-length
      const descSabugo: number =
        this.rs009CardIIIComponent.formulario.get('Desc_Sabugo').value;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (qtdePalhImpArdiEscl > 0 && descSabugo > 0) {
      resultado = descImpuPalh + descSabugo;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Total_Desc_Pal_Imp_Sabugo')
        .setValue(resultado);
    }

  }

  public async getPesoLiquidoUmido(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const pesoLiquido: number =
        this.rs009CardIComponent.formulario.get('Peso_Liquido')?.value ?? 0;
      // tslint:disable-next-line: max-line-length
      const totalDescPalImpSabugo: number =
        this.rs009CardIIIComponent.formulario.get('Total_Desc_Pal_Imp_Sabugo')
          ?.value ?? 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoLiquido > 0 && totalDescPalImpSabugo > 0) {
      resultado = pesoLiquido - totalDescPalImpSabugo;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Peso_Liquido_Umido')
        .setValue(resultado);
    }

  }

  public async getDescUmid(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const pesoLiquidoUmido: number =
        this.rs009CardIIIComponent.formulario.get('Peso_Liquido_Umido')?.value ??
        0;
      // tslint:disable-next-line: max-line-length
      const umidDeduzir: number =
        this.rs009CardIIIComponent.formulario.get('Umidade_Deduzir')?.value ?? 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoLiquidoUmido > 0 && umidDeduzir > 0) {
      resultado = (pesoLiquidoUmido * umidDeduzir) / 100;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Desconto_Umidade')
        .setValue(resultado);
    }

  }

  public async getPesoLiquidoSeco(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const pesoLiquidoUmido: number =
        this.rs009CardIIIComponent.formulario.get('Peso_Liquido_Umido')?.value ??
        0;
      // tslint:disable-next-line: max-line-length
      const descUmidade: number =
        this.rs009CardIIIComponent.formulario.get('Desconto_Umidade')?.value ?? 0;
      // tslint:disable-next-line: no-inferrable-types
      let resultado: number = 0;
      // if (pesoLiquidoUmido > 0 && descUmidade > 0) {
      resultado = pesoLiquidoUmido - descUmidade;
      // }
      // tslint:disable-next-line: max-line-length
      this.rs009CardIIIComponent.formulario
        .get('Peso_Liquido_Seco')
        .setValue(resultado);
    }

  }

  public async getRendimentoRw(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const pesoLiquido: number =
        this.rs009CardIComponent.formulario.get('Peso_Liquido').value;
      const pesoLiquidoSeco: number =
        this.rs009CardIIIComponent.formulario.get('Peso_Liquido_Seco').value;
      let resultado: number = 0;
      if (pesoLiquido > 0) {
        resultado = (pesoLiquidoSeco / pesoLiquido) * 100;
      } else {
        resultado = pesoLiquido;
      }

      this.rs009CardIIIComponent.formulario
        .get('Rendimento_Rw')
        .setValue(resultado);

      const qtdeRendimentoControl = this.rs009CardIIIComponent.formulario.get('Rendimento_Rw');
      qtdeRendimentoControl.setValue(resultado);
  
      qtdeRendimentoControl['warning'] = resultado > 10 ? true : false;
    }

  }

  public async getDescPalhaImpMilho(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      // tslint:disable-next-line: max-line-length
      const descPalhImpArdiEscler: number =
        (this.rs009CardIIIComponent.formulario.get('Desc_Palh_Imp_Ardi_Escler')
          ?.value as number) ?? 0;
      // tslint:disable-next-line: max-line-length
      const sabugo: number =
        (this.rs009CardIIComponent.formulario.get('Sabugo')?.value as number) ??
        0;
      let resultado: number = 0;
      resultado = descPalhImpArdiEscler + sabugo;
      this.rs009CardIIIComponent.formulario
        .get('Desc_Palh_Imp')
        .setValue(resultado);
    }

  }

  // FIM DO CODIGO DE CALCULO

  private async getUser(): Promise<void> {
    await this.formularioService
      .getUser()
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        this.rs009CardIIIComponent.userLogged =
          response['user-profile']?.displayName ?? 'Administrador';
        this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
        if (this.areaSelect.includes('Pré-Básica')) {

          this.rs009CardVComponent.formulario?.get('criado_por').setValue(this.currentUser);
        }
        else {

          this.rs009CardIIIComponent.formulario?.get('criado_por').setValue(this.currentUser);
        }

      })
      .catch(async (error) => {
        await this.generalService
          .getUserNameValue()
          .pipe(take(1))
          .toPromise()
          .then((response: string) => {
            this.rs009CardIIIComponent.userLogged = response ?? 'Administrador';
            this.currentUser = response ?? 'Administrador';
            if (this.areaSelect.includes('Pré-Básica')) {

              this.rs009CardVComponent.formulario?.get('criado_por').setValue(this.currentUser);
            }
            else {

              this.rs009CardIIIComponent.formulario?.get('criado_por').setValue(this.currentUser);
            }


          })
          .catch((err) => { });
      });
  }



  private async blockFieldValidacao(): Promise<void> {
    const validacao: boolean =
      this.rs009CardIIIComponent.formulario.get('validacao')?.value;
    if (validacao) {
      this.rs009CardIIIComponent.disableCheckbox = true;
    } else {
      this.rs009CardIIIComponent.disableCheckbox = false;
      await this.getUser();
    }
  }

  private async checkCerarExist(): Promise<boolean> {



    const cerar: string = this.generalService.isComercial || this.generalService.isBasica ? this.rs009CardIComponent.formulario.get('Cerar')?.value : this.rs009CardIComponent.formulario.get('cerar_basica')?.value;
    let result = false;
    try {
      if (this.generalService.isComercial || this.generalService.isBasica) {
        result = await this.formularioService.checkCerarExist(cerar, this.rs009CardIComponent.formulario, 'rs009');
      } else {
        result = await this.formularioService.checkCerarBasicaExist(cerar, this.rs009CardIComponent.formulario, 'rs009');
      }


    } catch (error) {
      this.notificationService.showNotificationError(error, error.message);
      if (localStorage.getItem('statusNetwork')) {
        let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
        if (isOnline) {
          if (this.generalService.isComercial || this.generalService.isBasica) {

            this.rs009CardIComponent.formulario.get('Cerar')?.setErrors({ invalidCerar: true });
          } else {
            this.rs009CardIComponent.formulario.get('cerar_basica')?.setErrors({ invalidCerar: true });
          }

        }
      }
    }

    return result;
  }

  makeCalcPreBasica($event) {
    //Calcular % palha + impureza do CERAR
    this.calcularPorcentagemPalhaImpurezaCerar();
    //Calcular % sabugo no cerar
    this.calcularPorcentagemSabugoCerar();
    //Calcular % semente no cerar
    this.calcularPorcentagemSementeCerar();
    //Calcular % palha da amostra
    this.calcularPorcentagemPalhaAmostra();
    //Calcular Peso líquido da carga com umidade
    this.calcularPesoLiquidoCargaUmidade();
    //Calcular kg de palha na carga
    this.calcularKgPalhaCarga();
    //Calcular Previsão de MPL (kg)
    this.calcularPrevisaoMplKg();
    //Calcular Previsão de MPL (%)
    this.calcularPrevisaoMplPorcento();
    //Calcular Previsão DS Grãos (kg)
    this.calcularPrevisaoDsGraosKg();
    //Calcular Previsão DS Grãos (%)  
    this.calcularPrevisaoDsGraosPorcento();
  }


  private calcularPorcentagemPalhaImpurezaCerar() {
    const palha = this.rs009CardIIComponent.formulario?.get('palha').value as number;
    const impurezas = this.rs009CardIIComponent.formulario?.get('impurezas').value as number;
    const pesoAmostra = this.rs009CardIIComponent.formulario?.get('peso_amostra').value as number;

    if (palha != null && impurezas != null && pesoAmostra != null) {
      const valor = (Number(palha) + Number(impurezas)) / Number(pesoAmostra);
      this.rs009CardIIIComponent.formulario?.get('palha_impureza_cerar').setValue(valor);
    }
    else {
      this.rs009CardIIIComponent.formulario?.get('palha_impureza_cerar').setValue(0);
    }
  }

  private calcularPorcentagemSabugoCerar() {
    const sabugo = this.rs009CardIIComponent.formulario?.get('sabugo_milho').value;
    const pesoAmostra = this.rs009CardIIComponent.formulario?.get('peso_amostra').value;

    if (sabugo != null && pesoAmostra != null) {
      const valor = Number(sabugo) / Number(pesoAmostra);
      this.rs009CardIIIComponent.formulario?.get('sabugo_cerar').setValue(valor);
    }
  }

  private calcularPorcentagemSementeCerar() {
    const pesoSementes = this.rs009CardIIComponent.formulario?.get('peso_sementes').value;
    const pesoAmostra = this.rs009CardIIComponent.formulario?.get('peso_amostra').value;

    if (pesoSementes != null && pesoAmostra != null) {
      const valor = Number(pesoSementes) / Number(pesoAmostra);
      this.rs009CardIIIComponent.formulario?.get('semente_cerar').setValue(valor);
    }
  }

  private calcularPorcentagemPalhaAmostra() {
    const pesoAmostra = Number(this.rs009CardIIComponent.formulario?.get('peso_amostra').value) || 0;
    const amostraSecaMolhada = this.rs009CardIComponent.formulario?.get('amostra_seca_molhada').value;
    const palhaImpurezaCerar = Number(this.rs009CardIIIComponent.formulario?.get('palha_impureza_cerar').value);

    if (pesoAmostra === 0) {
      this.rs009CardIIIComponent.formulario?.get('palha_amostra').setValue(0);
    } else if (amostraSecaMolhada === 'MOLHADA' && pesoAmostra != null) {
      this.rs009CardIIIComponent.formulario?.get('palha_amostra').setValue((palhaImpurezaCerar * 1.15) / pesoAmostra);
    } else if (amostraSecaMolhada === 'SECA' && pesoAmostra != null) {
      this.rs009CardIIIComponent.formulario?.get('palha_amostra').setValue(palhaImpurezaCerar / pesoAmostra);
    }
  }

  private calcularPesoLiquidoCargaUmidade() {
    const pesoLiquido = Number(this.rs009CardIIComponent.formulario?.get('peso_liquido').value);
    const sementeCerar = Number(this.rs009CardIIIComponent.formulario?.get('semente_cerar').value);

    if (pesoLiquido != null && sementeCerar != null) {
      const valor = pesoLiquido * sementeCerar;
      this.rs009CardIIIComponent.formulario?.get('peso_liquido_carga_umidade').setValue(valor);
    }
  }

  private calcularKgPalhaCarga() {
    const pesoLiquido = Number(this.rs009CardIIComponent.formulario?.get('peso_liquido').value);
    const palhaImpurezaCerar = Number(this.rs009CardIIIComponent.formulario?.get('palha_impureza_cerar').value);

    if (pesoLiquido != null && palhaImpurezaCerar != null) {
      const valor = pesoLiquido * palhaImpurezaCerar;
      this.rs009CardIIIComponent.formulario?.get('palha_na_carga').setValue(valor);
    }
  }

  private calcularPrevisaoMplKg() {
    const pesoLiquido = Number(this.rs009CardIIComponent.formulario?.get('peso_liquido').value);
    const sementeCerar = Number(this.rs009CardIIIComponent.formulario?.get('semente_cerar').value);
    const umidade = Number(this.rs009CardIComponent.formulario?.get('umidade').value);

    if (pesoLiquido != null && sementeCerar != null && umidade != null) {
      const fator = (umidade - 13) / (100 - 13);
      const valor = (pesoLiquido * sementeCerar) - (pesoLiquido * sementeCerar * fator);
      this.rs009CardIIIComponent.formulario?.get('previsao_mpl_kg').setValue(valor);
    }
  }

  private calcularPrevisaoMplPorcento() {
    const pesoSementes = Number(this.rs009CardIIComponent.formulario?.get('peso_sementes').value);
    const umidade = Number(this.rs009CardIComponent.formulario?.get('umidade').value);
    const pesoAmostra = Number(this.rs009CardIIComponent.formulario?.get('peso_amostra').value);

    if (pesoSementes != null && umidade != null && pesoAmostra != null) {
      const fator = (umidade - 13) / (100 - 13);
      const valor = (pesoSementes - (pesoSementes * fator)) / pesoAmostra;
      this.rs009CardIIIComponent.formulario?.get('previsao_mpl_porcento').setValue(valor);
    }
  }

  private calcularPrevisaoDsGraosKg() {
    const previsaoMplKg = Number(this.rs009CardIIIComponent.formulario?.get('previsao_mpl_kg').value);
    const perdaProcesso = Number(this.rs009CardIIIComponent.formulario?.get('perda_processo').value);
    const umidade = Number(this.rs009CardIComponent.formulario?.get('umidade').value);

    if (previsaoMplKg != null && perdaProcesso != null && umidade != null) {
      const fator = (umidade - 13) / (100 - 13);
      const valor = previsaoMplKg - (perdaProcesso - (perdaProcesso * fator));
      this.rs009CardIIIComponent.formulario?.get('previsao_ds_graos_kg').setValue(valor);
    }
  }

  private calcularPrevisaoDsGraosPorcento() {
    const previsaoDsGraosKg = Number(this.rs009CardIIIComponent.formulario?.get('previsao_ds_graos_kg').value);
    const pesoLiquido = Number(this.rs009CardIIComponent.formulario?.get('peso_liquido').value);

    if (previsaoDsGraosKg != null && pesoLiquido != null) {
      const valor = previsaoDsGraosKg / pesoLiquido;
      this.rs009CardIIIComponent.formulario?.get('previsao_ds_graos_porcento').setValue(valor);
    }
  }

  getDataFromRs005($event) {
    if (this.rs009CardIComponent.formulario?.get('safra').value && this.rs009CardIComponent.formulario?.get('numero_campo').value) {
      this.formularioService.getRS005Data(this.rs009CardIComponent.formulario?.get('safra').value, this.rs009CardIComponent.formulario?.get('numero_campo').value).pipe(take(1)).toPromise().then(async (result: any) => {
        this.rs009CardIIComponent.formulario?.get('descarte_mesa').setValue(result.data.descarte_mesa);
        this.rs009CardIIComponent.formulario?.get('espigas_atipicas').setValue(result.data.peso_espiga);
      }).catch(async () => {

      });
    }
  }

}
